import { EdgelessRootBlockSpec } from '@blocksuite/hive/blocks/root';
import { ToolbarModuleExtension } from '@blocksuite/hive/shared/services';
import {
  BlockFlavourIdentifier,
  LifeCycleWatcher,
} from '@blocksuite/hive/std';
import type { ExtensionType } from '@blocksuite/hive/store';
import type { FrameworkProvider } from '@toeverything/infra';

import { buildAIPanelConfig } from '../ai-panel';
import { toolbarAIEntryConfig } from '../entries';
import {
  edgelessToolbarAIEntryConfig,
  setupEdgelessCopilot,
} from '../entries/edgeless/index';
import { setupSpaceAIEntry } from '../entries/space/setup-space';
import { CopilotTool } from '../tool/copilot-tool';
import {
  HiveAIPanelWidget,
  aiPanelWidget,
} from '../widgets/ai-panel/ai-panel';
import {
  EdgelessCopilotWidget,
  edgelessCopilotWidget,
} from '../widgets/edgeless-copilot';
import { AiSlashMenuConfigExtension } from './ai-slash-menu';

export function createAIEdgelessRootBlockSpec(
  framework: FrameworkProvider
): ExtensionType[] {
  return [
    ...EdgelessRootBlockSpec,
    CopilotTool,
    aiPanelWidget,
    edgelessCopilotWidget,
    getAIEdgelessRootWatcher(framework),
    // In note
    ToolbarModuleExtension({
      id: BlockFlavourIdentifier('custom:hive:note'),
      config: toolbarAIEntryConfig(),
    }),
    ToolbarModuleExtension({
      id: BlockFlavourIdentifier('custom:hive:surface:*'),
      config: edgelessToolbarAIEntryConfig(),
    }),
    AiSlashMenuConfigExtension(),
  ];
}

function getAIEdgelessRootWatcher(framework: FrameworkProvider) {
  class AIEdgelessRootWatcher extends LifeCycleWatcher {
    static override key = 'ai-edgeless-root-watcher';

    override mounted() {
      super.mounted();
      const { view } = this.std;
      view.viewUpdated.subscribe(payload => {
        if (payload.type !== 'widget' || payload.method !== 'add') {
          return;
        }
        const component = payload.view;
        if (component instanceof HiveAIPanelWidget) {
          component.style.width = '430px';
          component.config = buildAIPanelConfig(component, framework);
          setupSpaceAIEntry(component);
        }

        if (component instanceof EdgelessCopilotWidget) {
          setupEdgelessCopilot(component);
        }
      });
    }
  }
  return AIEdgelessRootWatcher;
}
